<style>
  .article-content img {
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
    margin: 0 !important; /* 이미지 주위의 여백 제거 */
    padding: 0 !important; /* 이미지 주위의 패딩 제거 */
    display: block !important; /* 이미지의 주위에 생기는 공백 제거 */
  }
</style>
<template>
  <div class="row" style="padding: 20px">
    <div class="col-lg-12" style="margin-left: 10px">
      <div class="main-card mb-3 card">
        <table class="board_table">
          <tr>
            <th>제목</th>
            <td colspan="5">{{ article.title }}</td>
          </tr>
          <tr>
            <th>작성자</th>
            <td v-if="article.adminName">{{ article.adminName }}</td>
            <td v-else-if="article.studentName">{{ article.studentName }}</td>
            <th>작성일</th>
            <td>{{ article.created_at }}</td>
            <th>조회수</th>
            <td>{{ article.readCnt }}</td>
          </tr>
          <tr v-if="this.$route.params.board == '2024Summer'">
            <th v-if="article.addi_data1">말머리</th>
            <td v-if="article.addi_data1">{{ article.addi_data1 }}</td>
            <th v-if="article.addi_data2">학습일자</th>
            <td v-if="article.addi_data2">{{ article.addi_data2 }}</td>
          </tr>
          <tr v-if="this.$route.params.board == 'teacher'">
            <th v-if="article.addi_data1">Type</th>
            <td v-if="article.addi_data1">{{ article.addi_data1 }}</td>
            <th v-if="article.addi_data2">제출완료일</th>
            <td v-if="article.addi_data2">{{ article.addi_data2 }}</td>
          </tr>
          <tr v-if="this.$route.params.board == 'announce'">
            <th v-if="article.addi_data1">메인홈페이지 표시여부</th>
            <td v-if="article.addi_data1">
              {{ article.addi_data1 == "1" ? "O" : "X" }}
            </td>
            <th v-if="article.addi_data2">학원홈페이지 표시여부</th>
            <td v-if="article.addi_data2">
              {{ article.addi_data2 == "1" ? "O" : "X" }}
            </td>
          </tr>
          <tr >
            <td
              colspan="6"
              style="text-align: left" 
              v-html="article.content" class="article-content"
            ></td>
          </tr>
        </table>

        <div style="display: inline-block; text-align: right">
          <router-link  :to="'/events/'+this.$route.params.board"
            ><button class="btn btn-secondary">
              목&nbsp;&nbsp;록
            </button></router-link
          >
          <template v-if="eligible_to_modify">
            <router-link :to="this.$route.params.article + '/edit'"
              ><button class="btn btn-success">
                수&nbsp;&nbsp;정
              </button></router-link
            >
            <button class="btn btn-danger" @click="deleteArticle()">
              삭&nbsp;&nbsp;제
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    article: {},
    eligible_to_modify: false,
  }),
  methods: {
    loadArticle() {
      axios
        .get(
          "/articles_event/" +
            this.$route.params.board +
            "/articles/" +
            this.$route.params.article
        )
        .then((response) => {
          if (response.data.error) {
            alert("게시글을 불러올 수 없습니다.\n" + response.data.error);
          } else {
            this.article = response.data.result;
            if (response.data.eligible_to_modify) {
              this.eligible_to_modify = true;
            }
          }
        });
    },
    deleteArticle() {
      axios
        .delete(
          "/articles_event/" +
            this.$route.params.board +
            "/" +
            this.$route.params.article
        )
        .then((response) => {
          if (response.data.error) {
            alert("삭제 실패하였습니다.\n" + response.data.error);
          } else {
            $.notify(
              {
                // options
                message: "삭제되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.$router.push("./");
          }
        });
    },
  },
  mounted() {
    this.loadArticle();
  },
};
</script>
